import type { DeepRequired } from '../fixtures.types'

const deposit: DeepRequired<Deposit> = {
  __typename: 'Deposit',
  amount: null,
  deposit_for: null,
  document_verifies: null,
  documents: [],
  donors: [],
  donorsCp: [],
  id: 'TEST_ID',
  internalHash: null,
  source: null,
  type: null,
}

export default deposit
